import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import FileCopyTwoTone from '@material-ui/icons/FileCopyTwoTone'
import QuickResponsePopup from './model/QuickResponsePopup'
import {AutomationData} from '../../../Utils/Constant/automationData'
import {
  DeleteQuickAutomation,
  GetAutomationList,
  getQuickAutomationData,
} from './automationSlice/AutomationSlice'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import InsertNewData from '../../../Components/InsertNewData'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import MultiStepList from './multiStep/list'
import FlowList from '../Flow/FlowList/FlowList'
import { getAllUserDetails } from '../accounts/Overview/OverviewSlice/UserDetailsSlice'

const AutomationWrapper = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const quickAutomationData = useSelector(getQuickAutomationData)
  const [quickResponseModel, setQuickResponseModel] = useState(false)
  const [selectedData, setSelectedData] = useState<any>(null)
  const [deleteIds, setDeleteIds] = useState<string | null>(null)
  const [confirm, setConfirm] = useState<boolean>(false)

  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })

  useEffect(() => {
    dispatch(GetAutomationList(page))
  }, [page.page, page.size])

  useEffect(() => {
    if (confirm === true) {
      dispatch(DeleteQuickAutomation(deleteIds))
      setConfirm(false)
      setDeleteIds(null)
    }
  }, [confirm])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={!!deleteIds}
        stopClose={false}
        handleClose={() => setDeleteIds(null)}
        Message={'Are you sure, you want to delete Automation?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [deleteIds]
  )

  return (
    <>
      {confirmation}
      <QuickResponsePopup
        show={quickResponseModel}
        handleClose={() => {
          setQuickResponseModel(false)
          setSelectedData(null)
        }}
        selectedData={selectedData}
      />

      <div className='card mb-0'>
        <div className='card-header border-0 pt-12'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Quick responses</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Manage all keyword replies</span>
          </h3>
          <div className='card-toolbar m-0'>
            {AuthenticateUser('send-quick-sms') && (
              <div className='d-flex gap-3 align-items-center'>
                <button
                  className='btn btn-primary'
                  onClick={() => {
                    setQuickResponseModel(true)
                  }}
                >
                  Create new
                </button>
              </div>
            )}
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted text-uppercase'>
                    <th>RULE TITLE</th>
                    <th>RULE</th>
                    <th>SEARCH TERMS</th>
                    <th>MESSAGE</th>
                    <th>STATUS</th>
                    <th className='w-100px'>Action</th>
                  </tr>
                </thead>
                <tbody className='text-gray-600'>
                  {quickAutomationData?.items?.map((data: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td className='fw-bold cursor-pointer'>{data?.title}</td>
                        <td>{data?.rule}</td>
                        <td>{data?.searchTerm || '--'}</td>
                        <td>{data?.message}</td>
                        <td>
                          <span
                            className={`badge ${
                              data?.status ? 'badge-light-info' : 'badge-light-danger'
                            }`}
                          >
                            {data?.status ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td>
                          <div className='row'>
                            <a
                              className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              onClick={() => {
                                setSelectedData(data)
                                setQuickResponseModel(true)
                              }}
                            >
                              <span className='svg-icon svg-icon-3'>
                                <i className='bi bi-pencil-fill'></i>
                              </span>
                            </a>
                            <a
                              className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              onClick={() => setDeleteIds(data?._id)}
                            >
                              <span className='svg-icon svg-icon-3'>
                                <i className='bi bi-trash3-fill'></i>
                              </span>
                            </a>
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>

              <div className='abcd '>
                <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  {/* <option value={tagslist?.total}>ALL</option> */}
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={quickAutomationData?.totalPages}
                  onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <MultiStepList />
      <FlowList />
    </>
  )
}

export default AutomationWrapper
